import React, { useState } from 'react';
import { Modal, Button, Form, Col, Alert } from 'react-bootstrap';
import DatePicker from "react-datepicker";
 
import "react-datepicker/dist/react-datepicker.css";

const RegistrationModal = ({ date, show, closeHandler, registerCallback }) => {
    const [validated, setValidated] = useState(false);
    const [birthDate, setBirthDate] = useState(new Date());
    const [error, setError] = useState(null);

    const checkAge = () => {
        try {
            const now = new Date();
            const age = now.getFullYear() - birthDate.getFullYear();
            return age >= 13;
        } catch {
            return false;
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        const test = re.test(form.elements.formGridEmail.value.toLowerCase());
        if (form.elements.formGridFirstName.value === "" || form.elements.formGridName.value === "" || form.elements.formGridPhone.value === "" || !test) {
          setError("Un des champs est erroné.");
        }

        registerCallback({
            nom: form.elements.formGridName.value,
            prenom: form.elements.formGridFirstName.value,
            email: form.elements.formGridEmail.value,
            telephone: form.elements.formGridPhone.value,
            date: birthDate
        }).catch(() => setError("Un problème réseau est survenue. Veuillez réessayer plus tard."))
    };
    
    return(
        <Modal show={show} onHide={closeHandler}>
            <Modal.Header closeButton>
                <Modal.Title>Réserver une place ({date})</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form onSubmit={handleSubmit} id="myform">
                    <Form.Row>
                        <Form.Group as={Col} controlId="formGridFirstName">
                            <Form.Label>Prénom</Form.Label>
                            <Form.Control type="name" placeholder="Prénom"/>
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridName">
                            <Form.Label>Nom</Form.Label>
                            <Form.Control type="name" placeholder="Nom" />
                        </Form.Group>
                    </Form.Row>

                    <Form.Group controlId="formGridEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" placeholder="Email"/>
                    </Form.Group>

                    <Form.Group controlId="formGridPhone">
                        <Form.Label>Numéro de téléphone</Form.Label>
                        <Form.Control type="name" placeholder="Numéro" />
                    </Form.Group>

                    <Form.Group controlId="formGridBirth">
                        <Form.Label>Date de naissance</Form.Label>
                        <DatePicker
                            className="ml-3"
                            id="formGridDatepicker"
                            value={birthDate}
                            selected={birthDate} 
                            onChange={(value, formattedValue) => setBirthDate(value)}
                            dateFormat="dd/MM/yyyy"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select" />
                    </Form.Group>
                </Form>
                {error ? <Alert variant="danger">
                    {error}
                </Alert> : null}
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={closeHandler}>Annuler</Button>
                <Button variant="success" type="submit" form="myform" disabled={!checkAge()}>
                    Réserver
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default RegistrationModal;